import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import styles from './DownloadFile.module.less';

import Dialog from '../../components/Dialog/Dialog';
import { setOtherInfo } from '../../actions/native';
import { downloadShowFileError } from '../../actions/downloadTask';
import Toast from '../../components/Toast/Toast';
import { logging, logPostInfo } from '../../actions/log';
import { PCStoreJsBridge } from '../../nativeapi';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectOtherInfo = createSelector(
  state => state.native,
  native => native.otherInfo,
);
const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

export default () => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const otherInfo = useSelector(selectOtherInfo);
  const downloadSofts = useSelector(selectDownloadSofts);
  const inputRef = useRef();

  const [pathValue, setPathValue] = useState('');
  const [errorInfo, setErrorInfo] = useState('');

  useEffect(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Path_Fail_Dl',
        label: '',
        param2: {
          source: 'Path_Fail_Dl',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  // 初始化 拿到下载路径
  useEffect(() => {
    if (otherInfo) {
      setPathValue(otherInfo.DownLoadPath);
    }
  }, [otherInfo]);

  // 选择下载路径
  const handleBrowserFolder = useCallback(() => {
    const path = otherInfo.DownLoadPath || otherInfo.DefaultPath;
    PCStoreJsBridge.browserFolder(path).then(res => {
      setPathValue(res.DownLoadPath);
    });

    // 点击 打开选择下载文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Path_Fail_Dl',
        label: '',
        param2: {
          source: 'Path_Fail_Dl',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch, otherInfo]);

  const updateDownloadTasks = useCallback(() => {
    downloadSofts.forEach(item => {
      if (!item.pc && !item.apk && !item.attr) {
        return;
      }
      if (item.attr.act === 'error') {
        // 当任务没有结束直接报失败，判断一下为下载失败还是安装失败
        if (item.attr.statFrom == 'dl') {
          PCStoreJsBridge.downloadRetry({ ...item });
        }
      }
    });
  }, [downloadSofts]);

  // 设置下载路径
  const submitDownloadPath = useCallback(() => {
    const matchStrD = /^[(\u4e00-\u9fa5)|(0-9)|(a-z)|(A-Z)|(_)|( )|(\\)|(:)]+$/;
    // 设置下载路径
    const DownLoadPath = inputRef?.current?.value || '';

    dispatch(setOtherInfo({ DownLoadPath }));
    if (!DownLoadPath.match(matchStrD)) {
      let msg = '该路径无法下载应用，请修改后提交';
      setErrorInfo(msg);
      return;
    }
    // 点击 打开选择下载文件路径
    dispatch(
      logging({
        category: 'C',
        action: 'Path_Fail_Dl_Sure',
        label: '',
        param2: {
          source: 'Path_Fail_Dl',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    // 设置下载路径
    PCStoreJsBridge.setDownloadPath(DownLoadPath).then(
      data => {
        if (data.code === 0) {
          Toast.success({
            content: '下载软件路径，设置成功！',
          });
          updateDownloadTasks();
          dispatch(downloadShowFileError({ show: false, time: +new Date() }));
        } else {
          let msg = '该路径无法下载应用，请修改后提交';
          if (data.code === 4) {
            msg = '该路径无法下载应用，盘符不存在！';
          } else if (data.code === 2) {
            msg = '该路径无法下载应用，磁盘不可用！';
          } else if (data.code === 1) {
            msg = '该路径无法下载应用，磁盘空间不足！';
          }
          setErrorInfo(msg);
        }

        // 点击 打开选择下载文件路径
        dispatch(
          logging({
            category: 'R',
            action: 'Path_Fail_Dl_Succeed',
            label: '',
            param2: {
              source: 'Path_Fail_Dl',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              status: data.code === 0,
              code: data.code,
            },
          }),
        );
      },
      err => {
        setPathValue(otherInfo.DefaultPath);
        Toast.error({
          content: '下载路径设置失败！',
        });
      },
    );
  }, [inputRef, otherInfo, downloadSofts]);

  return (
    <>
      <Dialog
        title={'下载失败提醒'}
        maskStyle={styles.file_mask}
        containerStyle={styles.file_mask_container}
        handleClose={() => {
          dispatch(downloadShowFileError({ show: false, time: +new Date() }));
        }}
      >
        <div className={styles.file_content}>
          <div className={styles.file_content_text}>您当前的下载路径不可用，请您修改路径试试：</div>
          <div className={styles.file_content_input}>
            <input
              type="text"
              className={styles.file_input}
              readOnly
              ref={inputRef}
              value={pathValue}
              title={pathValue?.length > 20 ? pathValue : ''}
            />
            <div className={styles.file_content_input_info} onClick={handleBrowserFolder}>
              修改下载路径
            </div>
          </div>
          {errorInfo && (
            <div className={styles.file_content_error}>
              <span className={styles.file_content_error_icon} />
              {errorInfo}
            </div>
          )}

          <div className={styles.file_content_opt}>
            <div className={styles.file_content_btn} onClick={submitDownloadPath}>
              确认修改
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};
